/**
 * 重新组合四个数组，按照指定的交错顺序
 *
 * @param sSP126Arr 第一个气候情景数组
 * @param sSP245Arr 第二个气候情景数组
 * @param sSP370Arr 第三个气候情景数组
 * @param sSP585Arr 第四个气候情景数组
 * @returns 重组后的数组
 */
export function combineScenarioArrays(
  sSP126Arr: any[],
  sSP245Arr: any[],
  sSP370Arr: any[],
  sSP585Arr: any[]
): any[] {
  // 找出四个数组中的最大长度
  const maxLength = Math.max(
    sSP126Arr.length,
    sSP245Arr.length,
    sSP370Arr.length,
    sSP585Arr.length
  );

  const result: any[] = [];

  // 按照要求的顺序重组数组
  for (let i = 0; i < maxLength; i++) {
    // 添加每个数组的第i个元素
    if (i < sSP126Arr.length) result.push(sSP126Arr[i]);
    if (i < sSP245Arr.length) result.push(sSP245Arr[i]);
    if (i < sSP370Arr.length) result.push(sSP370Arr[i]);
    if (i < sSP585Arr.length) result.push(sSP585Arr[i]);
  }

  return result;
}
